'use client';

import { useSplitWizard } from '../model/split-wizard-context';
import { StepCompanySplit } from './steps/step-company-split';
import { StepPlanSplit } from './steps/step-plan-split';
import { StepPaymentSplit } from './steps/step-payment/step-payment-split';


export const OnboardingStepSwitch = () => {
    const { state } = useSplitWizard();

    switch (state.step) {
        case 'company':
            return <StepCompanySplit/>;

        case 'plan':
            return <StepPlanSplit/>;

        case 'payment':
            return <StepPaymentSplit/>;

        default:
            return null;
    }
};
